export const ROUTE_PATHS = {
  HOME: "/",
} as const;

export interface ContactInfo {
  phone: string;
  email: string;
  address: string;
}

export interface ShowroomLocation {
  id: string;
  city: string;
  address: string;
  phone: string;
  hours: string;
  mapUrl: string;
}

export const SHOWROOM_LOCATIONS: ShowroomLocation[] = [
  {
    id: "reggio-emilia",
    city: "Reggio Emilia",
    address: "Via Emilia all'Angelo, 39 - 42124 Reggio Emilia (RE)",
    phone: "+393294444151",
    hours: "",
    mapUrl: "https://mobilandiaemilia.it/contatti/",
  },
  {
    id: "medolla",
    city: "Medolla",
    address: "Via Sparato, 4 - 41036 Medolla (MO)",
    phone: "+393294444151",
    hours: "",
    mapUrl: "https://mobilandiaemilia.it/contatti/",
  },
  {
    id: "modena",
    city: "Modena",
    address: "Via Emilia Est, 929 - 41122 Modena (MO)",
    phone: "+393294444151",
    hours: "",
    mapUrl: "https://mobilandiaemilia.it/contatti/",
  },
  {
    id: "forli",
    city: "Forlì",
    address: "Via Pelacano, 6 - 47122 Forlì (FC)",
    phone: "+393294444151",
    hours: "",
    mapUrl: "https://mobilandiaemilia.it/contatti/",
  },
];

export const CONTACT_INFO: ContactInfo = {
  phone: "+393294444151",
  email: "info@mobilandiaemilia.it",
  address: "Via Emilia all'Angelo, 39 - 42124 Reggio Emilia (RE)",
};

export const PROMOTION_DETAILS = {
  discount: "50%",
  brand: "Giessegi",
  category: "Camerette",
  validUntil: "2026-03-29",
} as const;

export const COMPANY_INFO = {
  name: "Mobilandia",
  foundedYear: 1976,
  experience: "50+",
  regions: ["Piemonte", "Emilia-Romagna"],
} as const;
